import React, { useState } from 'react'
import Container from '../../layouts/Container/Container'
import Button from '../atoms/Button'

import {
  stQuiz
} from './../../utils/helpers'
import { connect } from 'react-redux'
// import { sendDataLayer } from '../../utils/functions'

function TestQuestions({
  token
}) {
  const [yesOrNot, setYesOrNot] = useState(false)
  const [response, setResponse] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [ok, serOk] = useState(false)
  const [hoveredOption, setHoveredOption] = useState(null);

  const respond = (str) => {
    setYesOrNot(str)
  }
  const handleQuiz = () => {
    // sendDataLayer({datalayer: { event: 'survey', text_title: '¿Te pareció útil este contenido?', message: yesOrNot, text: "Enviar" },repeat: true})
    
    if (!ok) {
      setIsLoading(true)
  
      stQuiz(token, yesOrNot, response).then((res) => {
  
        if (res && res.statusCode === 200) {
          setYesOrNot(false)
          setResponse("")
          serOk(true)
        }
        setIsLoading(false)
      }).catch(() => {
        setIsLoading(false)
      })
    }

  }
  const handleChange = async (e) => {
    if (e.target.value.length <= 500) setResponse(e.target.value)
  }

  return (
    <div className={`mc-test-questions`}>
      <Container>
        {!ok &&
          <h4>
          ¿Estás satisfecho con tu experiencia en la plataforma?
          </h4>
        }
        
        {!ok &&
          <div className='mc-test-questions--buttons'>
            <button className={`button-quiz ${yesOrNot === 'Si' ? 'active': ''}`} onClick={() =>respond('Si')} onMouseEnter={() => setHoveredOption('Si')} onMouseLeave={() => setHoveredOption(null)}>
              {(yesOrNot === 'Si' || hoveredOption === 'Si')
              ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_4810_8799)">
                  <path d="M4.66683 14.6666H2.66683C2.31321 14.6666 1.97407 14.5261 1.72402 14.2761C1.47397 14.026 1.3335 13.6869 1.3335 13.3333V8.66659C1.3335 8.31296 1.47397 7.97383 1.72402 7.72378C1.97407 7.47373 2.31321 7.33325 2.66683 7.33325H4.66683M9.3335 5.99992V3.33325C9.3335 2.80282 9.12278 2.29411 8.74771 1.91904C8.37264 1.54397 7.86393 1.33325 7.3335 1.33325L4.66683 7.33325V14.6666H12.1868C12.5084 14.6702 12.8204 14.5575 13.0654 14.3493C13.3105 14.141 13.4719 13.8512 13.5202 13.5333L14.4402 7.53325C14.4692 7.34216 14.4563 7.14704 14.4024 6.96142C14.3485 6.7758 14.2549 6.60412 14.1281 6.45826C14.0012 6.31241 13.8442 6.19587 13.6679 6.11673C13.4915 6.03759 13.3001 5.99773 13.1068 5.99992H9.3335Z" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_4810_8799">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_4810_8799)">
                  <path d="M4.66683 14.6666H2.66683C2.31321 14.6666 1.97407 14.5261 1.72402 14.2761C1.47397 14.026 1.3335 13.6869 1.3335 13.3333V8.66659C1.3335 8.31296 1.47397 7.97383 1.72402 7.72378C1.97407 7.47373 2.31321 7.33325 2.66683 7.33325H4.66683M9.3335 5.99992V3.33325C9.3335 2.80282 9.12278 2.29411 8.74771 1.91904C8.37264 1.54397 7.86393 1.33325 7.3335 1.33325L4.66683 7.33325V14.6666H12.1868C12.5084 14.6702 12.8204 14.5575 13.0654 14.3493C13.3105 14.141 13.4719 13.8512 13.5202 13.5333L14.4402 7.53325C14.4692 7.34216 14.4563 7.14704 14.4024 6.96142C14.3485 6.7758 14.2549 6.60412 14.1281 6.45826C14.0012 6.31241 13.8442 6.19587 13.6679 6.11673C13.4915 6.03759 13.3001 5.99773 13.1068 5.99992H9.3335Z" stroke="#0043A9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_4810_8799">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              }
              
              Sí
            </button>
            <button className={`button-quiz ${yesOrNot === 'No' ? 'active': ''}`} onClick={() =>respond('No')} onMouseEnter={() => setHoveredOption('No')} onMouseLeave={() => setHoveredOption(null)}>
              {(yesOrNot === 'No' || hoveredOption === 'No')
                ? <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clipPath="url(#clip0_4810_8804)">
                    <path d="M11.8334 1.33325H13.6134C13.9907 1.32658 14.3573 1.45867 14.6436 1.70446C14.93 1.95025 15.1161 2.29262 15.1667 2.66658V7.33325C15.1161 7.70721 14.93 8.04958 14.6436 8.29537C14.3573 8.54116 13.9907 8.67325 13.6134 8.66658H11.8334M7.16669 9.99991V12.6666C7.16669 13.197 7.3774 13.7057 7.75247 14.0808C8.12755 14.4559 8.63625 14.6666 9.16669 14.6666L11.8334 8.66658V1.33325H4.31335C3.9918 1.32961 3.67977 1.44231 3.43475 1.65058C3.18973 1.85884 3.02824 2.14864 2.98002 2.46658L2.06002 8.46658C2.03102 8.65768 2.0439 8.85279 2.09779 9.03841C2.15168 9.22403 2.24529 9.39572 2.37211 9.54157C2.49894 9.68743 2.65597 9.80396 2.83231 9.8831C3.00864 9.96225 3.20008 10.0021 3.39335 9.99991H7.16669Z" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_4810_8804">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                    </defs>
                  </svg>
                : <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clipPath="url(#clip0_4810_8804)">
                    <path d="M11.8334 1.33325H13.6134C13.9907 1.32658 14.3573 1.45867 14.6436 1.70446C14.93 1.95025 15.1161 2.29262 15.1667 2.66658V7.33325C15.1161 7.70721 14.93 8.04958 14.6436 8.29537C14.3573 8.54116 13.9907 8.67325 13.6134 8.66658H11.8334M7.16669 9.99991V12.6666C7.16669 13.197 7.3774 13.7057 7.75247 14.0808C8.12755 14.4559 8.63625 14.6666 9.16669 14.6666L11.8334 8.66658V1.33325H4.31335C3.9918 1.32961 3.67977 1.44231 3.43475 1.65058C3.18973 1.85884 3.02824 2.14864 2.98002 2.46658L2.06002 8.46658C2.03102 8.65768 2.0439 8.85279 2.09779 9.03841C2.15168 9.22403 2.24529 9.39572 2.37211 9.54157C2.49894 9.68743 2.65597 9.80396 2.83231 9.8831C3.00864 9.96225 3.20008 10.0021 3.39335 9.99991H7.16669Z" stroke="#0043A9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_4810_8804">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                    </defs>
                  </svg>
              }
              No
            </button>
          </div>
        }

        {!ok &&
          <div className={`mc-test-questions--details slow_ani  active ${isLoading ? 'loading' : ''}`}>
            <p>
              {
                yesOrNot === 'Si'
                  ? 'Cuéntanos más detalles'
                  : 'Cuéntanos más detalles'
              }
            </p>
            <textarea className={!yesOrNot ? 'disabled' : 'true'} disabled={yesOrNot ? false : true} onChange={handleChange} value={`${response ? response : ''}`} placeholder='Escribe aquí tus comentarios'></textarea>
            <span className='mc-test-questions--live'>{response ? response.length : 0} de 500 caractéres</span>
            <Button
              type="secondary"
              text="Enviar"
              loading={isLoading}
              status={yesOrNot === 'Si' ? 'active' : yesOrNot === 'No' ? 'active' : 'inactive'}
              onClick={handleQuiz}
            />
          </div>
        }

        {ok &&
          <>
            <img src='/assets/images/metas_imparable.png'></img>
            <p className='quizzok'>¡Gracias por la respuesta!</p>
          </>
        }
      </Container>
    </div>
  )
}

const mapState = ({ user: {token} }) => {
  return {
    token
  }
}

export default connect(mapState, {})(TestQuestions)